module.exports = __webpack_public_path__ + "static/img/3.4a4f405.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fu_shen/3.png
// module id = oBOQ
// module chunks = 0